export const environment = {
    production: false,
    api_endpoint: 'https://internalcoredev.azurewebsites.net',
    // api_endpoint: 'https://localhost:7063',
};
